import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DisplayManagerService } from '@com-delta-idp/mnx-skymiles-shared';
import { Benefits, Stack } from './models/benefits.interfaces';

@Component({
  selector: 'idp-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss'],
  providers: [DisplayManagerService],
  encapsulation: ViewEncapsulation.None
})
export class BenefitsComponent implements OnChanges {
  @Input() content: Benefits = {} as Benefits;
  @ViewChild('swipeZone') swipeZoneElement!: ElementRef;

  constructor(public displayManagerService: DisplayManagerService) {}

  ngOnChanges(): void {
    this.init();
  }

  init(): void {
    if (this.content.stacks && this.content.stacks.length)
      this.displayManagerService.init(
        this.getIndex(this.content),
        this.swipeZoneElement
      );
  }

  getIndex(content: Benefits): number {
    let index = 0;
    if (content.stacks.length === 1) {
      index = 0;
    } else {
      content.stacks.forEach((stack: Stack, stackIndex: number) => {
        if (stack.current) {
          index = stackIndex;
        }
      });
    }
    return index;
  }

  getAriaLabels(stack: Stack[]): string[] {
    const ariaLabels: string[] = [];
    if (stack) {
      stack.forEach((stack: Stack) => {
        ariaLabels.push(stack.ariaLabels.banner);
      });
    }
    return ariaLabels;
  }
}
